import { useSearchResults } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	isLoading: boolean;
}>;

export function useMobileFilters(): Result {
	const results = useSearchResults();

	return {
		data: {
			isLoading: results.isInitialLoad,
		},
	};
}
